import React from "react";
import style from "./Buttons.module.css";
export default function UpgradeButton(props) {
  const { text = "Upgrade", btnClass = "", ...restProps } = props;
  return (
    <button className={`${style.upgradeBtn} ${btnClass}`} {...restProps}>
      {text}
    </button>
  );
}
